function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var SvgSideEffects = function SvgSideEffects(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M18.203 1.854a.976.976 0 00-.824.359l-1.502 1.816A9.767 9.767 0 0012 3.227c-5.317 0-9.65 4.224-9.65 9.462 0 5.239 4.333 9.461 9.65 9.461s9.65-4.222 9.65-9.46c0-2.03-.656-3.904-1.761-5.442l.707-.855a.931.931 0 00.117-.993.933.933 0 00-.838-.521h-1.13l.353-1.89v-.005a.973.973 0 00-.895-1.13zM17.586 4l-.406 2.18h1.904l-2.543 3.076.404-2.174h-1.904L17.586 4zM12 4.527c1.063 0 2.074.2 3.008.553l-1.479 1.79a.928.928 0 00.721 1.513h1.13l-.35 1.892a.963.963 0 00.216.795v.002a.973.973 0 00.74.338h.002c.292 0 .572-.13.758-.361l2.281-2.758a7.988 7.988 0 011.323 4.398c0 4.495-3.725 8.16-8.35 8.16s-8.35-3.665-8.35-8.16c0-4.494 3.725-8.162 8.35-8.162zm3.03 5.748l-.01.053v.063l.01-.116zm-2.798 4.575c-.96 0-1.855.43-2.67 1.17a.65.65 0 10.876.96c.652-.593 1.248-.83 1.794-.83.55 0 1.17.24 1.868.842a.65.65 0 10.847-.984c-.85-.732-1.757-1.158-2.715-1.158z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible",
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSideEffects, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/side-effects.adaaf81d.svg";
export { ForwardRef as ReactComponent };